export default {
  global: {
    html: {
      fontSize: '62.5%'
    },
    body: {
      bg: '#fcfcfc',
      color: '#888888',
      fontSize: '1.4rem',
      fontFamily: "'Poppins', sans-serif"
    },
    a: {
      _hover: {
        textDecoration: 'none'
      }
    },
    '*': {
      margin: 0,
      padding: 0
    },
    '.chakra-pin-input': {
      flexGrow: 1,
      height: '4.8rem !important',
      borderRadius: '0.8rem !important',
      fontSize: '20px !important',
      borderColor: '#DDDDDD !important'
    },
    '@keyframes blinker': {
      from: { opacity: '1.0' },
      to: { opacity: '0.0' }
    },
    '.chakra-switch__track': {
      _focus: {
        boxShadow: 'none !important'
      }
    },
    '.toastContainer': {
      zIndex: '1550 !important'
    },
    '.toast.success': {
      backgroundColor: 'rgba(40,51,65,1) !important'
    },
    '.chakra-checkbox': {
      alignItems: 'flex-start !important'
    },
    '.chakra-checkbox__control': {
      borderRadius: '4px !important',
      borderColor: '#DDDDDD !important',
      width: '16px !important',
      height: '16px !important',
      borderWidth: '1px !important',
      marginTop: '2px',
      marginRight: '10px'
    },
    '.chakra-select': {
      paddingInline: '1.6rem !important'
    },
    '.chakra-select:focus': {
      border: '1px solid #4D80E4 !important'
    },
    '.containerScroll': {
      overflowY: 'scroll',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    },
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '.rdt input': {
      width: '100%',
      outline: '2px solid transparent',
      outlineOffset: '2px',
      position: 'relative',
      transitionProperty: 'var(--chakra-transition-property-common)',
      transitionDuration: 'var(--chakra-transition-duration-normal)',
      padding: '2.7rem 1.6rem',
      border: '1px solid #DDDDDD',
      borderRadius: '1rem',
      fontSize: '1.4rem',
      color: '#41546c',
      height: '4.5rem'
    },
    '::placeholder': {
      fontSize: '1.2rem',
      color: '#888888'
    },
    '.custom-rdt input': {
      border: 'none',
      height: '1.8rem',
      padding: 0,
      color: 'black',
      fontSize: '1.2rem'
    },
    '.chakra-modal__body': {
      background: 'white'
    }
  }
}
